import { useMutation, useQuery, useQueryClient, UseQueryResult } from "@tanstack/react-query";
import { staffApi } from "./staffApi";
import { SettlementType } from "../types/dtos";

export function useSettlementTypes(includeInactive = false): UseQueryResult<SettlementType[]> {
  return useQuery({
    queryKey: ["settlement-types", { includeInactive }],
    queryFn: async () =>
      (await staffApi.get<SettlementType[]>("/settlement-types", { params: { includeInactive } })).data,
  });
}

export function useCreateSettlementType() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (name: string) => staffApi.post("/settlement-types", { name }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["settlement-types"] }),
  });
}

export function useUpdateSettlementType() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: number; input: Partial<{ name: string; active: boolean }> }) =>
      staffApi.patch(`/settlement-types/${id}`, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["settlement-types"] }),
  });
}

export function useDeleteSettlementType() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => staffApi.delete(`/settlement-types/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["settlement-types"] }),
  });
}
